module.exports = __webpack_public_path__ + "img/icon_activity2020.e14d9861.jpeg";